<p-drawer
  [visible]="(layoutService.drawerVisible$ | async) ?? false"
  (visibleChange)="onVisibleChange($event)"
  position="right"
  [styleClass]="styleClass"
  [showCloseIcon]="showCloseIcon"
>
  <ng-content select="[ui-drawer-content]"></ng-content>
</p-drawer>
